import * as graphql from 'generated/graphql';
import { currencyAndDecimalFieldPolicy } from './fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const PriceTier: ITypeSpecificPolicy<graphql.PriceTier> = {
  fields: {
    unitAmount: currencyAndDecimalFieldPolicy()
  }
};
